import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticStyle:{"margin-top":"10px"}},[_c(VLayout,[_c(VFlex,{staticStyle:{"margin":"auto"},attrs:{"xs12":"","sm12":"","md8":"","lg8":"","xl8":""}},[_c(VCard,[_c(VCardText,[_c('div',[_c('post',{key:_vm.post.postId,attrs:{"item":_vm.post,"editable":false}})],1)])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }